import Vue from 'vue';
import App from './App.vue';
import io from 'socket.io-client';
import VueSocketIOExt from 'vue-socket.io-extended';

import GAuth from 'vue-google-oauth2'
const gauthOption = {
  clientId: '905546620985-406js8r05phjb7257a3vtjlmu6891imv.apps.googleusercontent.com'
}
Vue.use(GAuth, gauthOption)

const socket = io('https://gentle-gorge-36916.herokuapp.com')

Vue.use(VueSocketIOExt, socket);

new Vue({
  render: h => h(App),
}).$mount('#app');
